import React, { useState } from 'react';
import Modal from 'components/UI/DialogModal';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';
import { ISelectedEmployeesForInvitation } from 'models/workshopInvitations';
import { CircularProgress, Grid } from '@mui/material';
import { DualListBox } from 'components/UI/DualList';

interface Props {
  open: boolean;
  loading: boolean;
  uninvitedEmployeesList: ISelectedEmployeesForInvitation[];
  onClose: () => void;
  onSubmit: (data:string) => void;
}

const AddWorkshopInvitations2: React.FC<Props> = ({ open, loading,
  uninvitedEmployeesList,
  onClose, onSubmit }) => {

  const { t } = useTranslation()
 const [selectedEmployees,setSelectedEmployees] = useState<string>('') 

  const onSelectedEmployees = (data: ISelectedEmployeesForInvitation[]) => {
    setSelectedEmployees(data.map(item => item.id).join(';'));
  };


  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_invitation')}
      maxWidth="lg"
      fullScreen
      children={<div style={{padding:2}} >
        <DualListBox options={uninvitedEmployeesList} onSelectedEmployees={onSelectedEmployees}/>
      </div>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={()=>onSubmit(selectedEmployees)}>
            {t('T_send_invitations')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddWorkshopInvitations2;
